import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/index.js'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'uz', // set locale
    fallbackLocale: 'oz',
    messages // set locale messages
})

const loadedLanguages = ['oz'] // our default language that is preloaded

function setI18nLanguage(lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export function loadLanguageAsync(lang) {
    return new Promise(resolve => {
        // If the same language
        if (i18n.locale === lang) {
            return resolve(setI18nLanguage(lang))
        }

        // If the language was already loaded
        if (loadedLanguages.includes(lang)) {
            return resolve(setI18nLanguage(lang))
        }
    })
}